






import { ScriptLoader } from '@/util/scriptLoader'
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

interface AmazonPayOnetimeOption {
  merchantId: string
  sandbox: boolean
  /*
   * APIから返却された値をそのまま使う前提なので、詳細な型定義は省略している.
   * 仮にpayloadの内容をもとに何かしら値を算出する必要が生じたとしても、
   * その算出はサーバー側で行った上で注入し、client側ではその詳細を把握しなくて済むようにすることを想定している.
   */
  payload: object
  signature: string
  publicKeyId: string
}
@Component
/**
 * @file src/Model/Payment/Kind/AmazonPayOneTime.php サーバー側が返すhtmlにを通じてレンダリングされる
 * @see https://my-color.esa.io/posts/865
 */
export default class AmazonPayOnetime extends Vue {
  @Prop({ required: true })
  readonly options: AmazonPayOnetimeOption

  async created() {
    const amazon = await ScriptLoader.getInstanceFor<any>({
      src: 'https://static-fe.payments-amazon.com/checkout.js',
      global: 'amazon',
    }).load()

    /**
     * このスクリプト実行によってAmazonPayボタンがレンダリングされる.
     *
     * ボタンサイズの調整は特に行っていない.
     * この点については https://github.com/my-color/front/pull/7085 の注意事項も参照.
     */
    amazon.Pay.renderButton('#AmazonPayButton', {
      // set checkout environment
      merchantId: this.options.merchantId,
      ledgerCurrency: 'JPY',
      sandbox: this.options.sandbox,
      // customize the buyer experience
      checkoutLanguage: 'ja_JP',
      productType: 'PayAndShip',
      placement: 'Cart',
      buttonColor: 'Gold',
      // configure Create Checkout Session request
      createCheckoutSessionConfig: {
        payloadJSON: JSON.stringify(this.options.payload),
        signature: this.options.signature,
        publicKeyId: this.options.publicKeyId,
      },
    })
  }
}
